import React from 'react';
import './setting.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { message,Spin ,Checkbox} from "antd";
class Setting extends React.Component {
    state = {
        androidAppVersion:"",
        iosAppVersion:"",
        secondLang:false,
        Setting:[],
        loading:true,
        whatsappNumber:'',
        maxFriends:0,
        regionKm:0,
        id:0
        
    };

    constructor(props){
        super(props)
        window.scrollTo(0,0)
        this.getSetting()
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        this.getSetting()
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }
    /**
   * get data request 
   */
    getSetting = () =>{
        this.setState({loading:true})
        axios.get(`${BASE_END_POINT}setting`,{
          headers:{
            'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
          }
        })
        .then(response=>{
          console.log("Setting   ",response.data)
          this.setState({
            loading:false,
            Setting:response.data.data,
            androidAppVersion:response.data.data.androidAppVersion,
            iosAppVersion:response.data.data.iosAppVersion,
            secondLang:response.data.data.secondLang,
            whatsappNumber:response.data.data.WhatsappNumber,
            maxFriends:response.data.data.maxFriends,
            regionKm:response.data.data.regionKm,
            id:response.data.data.id,
          })
        })
        .catch(error=>{
          console.log("error   ",error.response)
          console.log("error2   ",error)
          this.setState({loading:false,})
        })
    }
    /**
    * update data request 
    */
    update = () => {
        const {androidAppVersion,iosAppVersion,secondLang,whatsappNumber,maxFriends,
            regionKm} = this.state
            let l = message.loading('Wait..', 2.5)
            const data={
                "androidAppVersion":androidAppVersion,
                "iosAppVersion":iosAppVersion,
                "secondLang":secondLang,
                "whatsappNumber":whatsappNumber,
                "maxFriends":maxFriends,
                "regionKm":regionKm
            }
            console.log(data)
            axios.put(`${BASE_END_POINT}setting/${this.state.id}`,JSON.stringify(data),{
            headers: {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${this.props.currentUser.token}`,
            'Accept-Language':this.props.isRTL?'ar':'en'
            },
            })
            .then(response=>{
            console.log("Setting UPDATED  ",response.data)
            l.then(() => message.success(allStrings.done, 2.5) )
            this.props.history.goBack() 
            })
            .catch(error=>{
                console.log(error.response)
                l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
            })
        
    }

   

    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.update()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    onChange = (e) =>{
        console.log(`checked = ${e.target.checked}`);
        this.setState({secondLang :e.target.checked})
    }
  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('SETTING')) return <Redirect to='/Home' />

  return (
    <div className="App">
        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{color:'#117183'}}>
        <MDBContainer> 
            <MDBRow>  
                <MDBCol md="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        
                        <div style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon" style={{background:'#117183'}}>
                                <span className="material-icons" style={{color:'white',fontSize:23}}>info</span>
                            </div>
                            <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                            marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                            <p>{allStrings.setting}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            
                            <MDBRow>
                                <MDBCol md="12">
                                <form
                                className="needs-validation"
                                onSubmit={this.submitHandler}
                                noValidate
                                >
                                    
                                    <div className="grey-text">
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form5" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.androidAppVersion}</label>
                                            <input   style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.Setting?this.state.Setting.androidAppVersion:0} type="text"  id="form5" name="androidAppVersion" className="form-control" onChange={this.changeHandler} required  validate/>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form55" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.iosAppVersion}</label>
                                            <input   style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.Setting?this.state.Setting.iosAppVersion:0} type="text" id="form55" name="iosAppVersion" className="form-control" onChange={this.changeHandler} required  validate/>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form5" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.regionKm}</label>
                                            <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.Setting?this.state.Setting.regionKm:0} type="text"  id="form5" name="regionKm" className="form-control" onChange={this.changeHandler} required  validate/>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form55" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.maxFriends}</label>
                                            <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.Setting?this.state.Setting.maxFriends:0} type="text" id="form55" name="maxFriends" className="form-control" onChange={this.changeHandler} required  validate/>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form5" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.whatsappNumber}</label>
                                            <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.Setting?this.state.Setting.whatsappNumber:0} type="text"  id="form5" name="whatsappNumber" className="form-control" onChange={this.changeHandler} required  validate/>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                    <Checkbox onChange={this.onChange} style={{paddingLeft:'6px',paddingRight:'6px'}}></Checkbox>
                                    <span>{allStrings.sencondLang}</span>
                                    </MDBRow>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <div className="text-center">
                                        <MDBBtn
                                        type="submit" style={{background:'#117183',color:'#fff'}}
                                        rounded
                                        className="btn-block z-depth-1a"
                                        >
                                        <MDBIcon icon="edit" className="mr-2" />
                                            {allStrings.edit}          
                                        </MDBBtn>
                                       
                                    </div>
                                </form>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol>
            </MDBRow>
      </MDBContainer>
      </Spin>
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(Setting)
  );